"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: miimosa/common/v1/reservation.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.reservationKindToJSON = exports.reservationKindFromJSON = exports.ReservationKind = void 0;
/* eslint-disable */
exports.ReservationKind = {
    /** RESERVATION_KIND_UNSPECIFIED - All */
    RESERVATION_KIND_UNSPECIFIED: "RESERVATION_KIND_UNSPECIFIED",
    RESERVATION_KIND_DEPARTMENT: "RESERVATION_KIND_DEPARTMENT",
    RESERVATION_KIND_EMAIL: "RESERVATION_KIND_EMAIL",
    /** RESERVATION_KIND_TRACKING_URL - deprecated */
    RESERVATION_KIND_TRACKING_URL: "RESERVATION_KIND_TRACKING_URL",
    RESERVATION_KIND_POSTAL_CODE: "RESERVATION_KIND_POSTAL_CODE",
    RESERVATION_KIND_EMAIL_DOMAIN: "RESERVATION_KIND_EMAIL_DOMAIN",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function reservationKindFromJSON(object) {
    switch (object) {
        case 0:
        case "RESERVATION_KIND_UNSPECIFIED":
            return exports.ReservationKind.RESERVATION_KIND_UNSPECIFIED;
        case 1:
        case "RESERVATION_KIND_DEPARTMENT":
            return exports.ReservationKind.RESERVATION_KIND_DEPARTMENT;
        case 2:
        case "RESERVATION_KIND_EMAIL":
            return exports.ReservationKind.RESERVATION_KIND_EMAIL;
        case 3:
        case "RESERVATION_KIND_TRACKING_URL":
            return exports.ReservationKind.RESERVATION_KIND_TRACKING_URL;
        case 4:
        case "RESERVATION_KIND_POSTAL_CODE":
            return exports.ReservationKind.RESERVATION_KIND_POSTAL_CODE;
        case 5:
        case "RESERVATION_KIND_EMAIL_DOMAIN":
            return exports.ReservationKind.RESERVATION_KIND_EMAIL_DOMAIN;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.ReservationKind.UNRECOGNIZED;
    }
}
exports.reservationKindFromJSON = reservationKindFromJSON;
function reservationKindToJSON(object) {
    switch (object) {
        case exports.ReservationKind.RESERVATION_KIND_UNSPECIFIED:
            return "RESERVATION_KIND_UNSPECIFIED";
        case exports.ReservationKind.RESERVATION_KIND_DEPARTMENT:
            return "RESERVATION_KIND_DEPARTMENT";
        case exports.ReservationKind.RESERVATION_KIND_EMAIL:
            return "RESERVATION_KIND_EMAIL";
        case exports.ReservationKind.RESERVATION_KIND_TRACKING_URL:
            return "RESERVATION_KIND_TRACKING_URL";
        case exports.ReservationKind.RESERVATION_KIND_POSTAL_CODE:
            return "RESERVATION_KIND_POSTAL_CODE";
        case exports.ReservationKind.RESERVATION_KIND_EMAIL_DOMAIN:
            return "RESERVATION_KIND_EMAIL_DOMAIN";
        case exports.ReservationKind.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.reservationKindToJSON = reservationKindToJSON;
//# sourceMappingURL=reservation.js.map